import MaterialTableContainer, {
    TableContainerProps,
} from '@mui/material/TableContainer';

export function TableContainer(props: TableContainerProps) {
    return (
        <MaterialTableContainer
            data-testid={'TableContainer-container'}
            {...props}
        />
    );
}

export default TableContainer;
